import api from './api'
import type { User } from '../types'

export interface AuthTokenResponse {
  access_token: string
  refresh_token: string
  token_type: string
  expires_in: number
  user: User
}

export const authApi = {
  loginWithPassword: async (payload: { phone: string; password: string }): Promise<AuthTokenResponse> =>
    api.post('/auth/login', payload),
  loginWithCode: async (payload: { phone: string; sms_code: string }): Promise<AuthTokenResponse> =>
    api.post('/auth/login/code', payload),
  register: async (payload: {
    phone: string
    password: string
    sms_code: string
    nickname?: string
    invite_code?: string
  }): Promise<AuthTokenResponse> => api.post('/auth/register', payload),
  sendSmsCode: async (payload: {
    phone: string
    purpose: 'register' | 'login' | 'reset'
  }): Promise<{ phone: string; expire_seconds: number; delivered: boolean }> =>
    api.post('/auth/sms-code', payload),
  changePassword: async (payload: { old_password: string; new_password: string }) =>
    api.post('/users/change-password', payload),
  resetPassword: async (payload: { phone: string; sms_code: string; new_password: string }) =>
    api.post('/users/reset-password', payload),
  getCurrentUser: async (): Promise<User> => api.get('/users/me'),
  updateCurrentUser: async (payload: { nickname?: string; avatar_url?: string; email?: string; onboarding_state?: Record<string, unknown> }): Promise<User> =>
    api.put('/users/me', payload),

  uploadAvatar: async (file: File): Promise<{ avatar_url: string }> => {
    const formData = new FormData()
    formData.append('file', file)
    return api.post('/users/me/avatar', formData)
  },
}

export default authApi
